const hasDescription = (header) => {
    return !!(header && header.description && header.description.type === "html" && header.description.body);
};
const hasSuperTitle = (header) => {
    return !!(header && header.supertitle);
};
const hasTitle = (header) => {
    return !!(header && header.title);
};
const hasSubtitle = (header) => {
    return !!(header && header.subtitle);
};
export const hasVisibleContent = (header) => {
    return !!(hasSuperTitle(header) || hasTitle(header) || hasSubtitle(header) || hasDescription(header));
};
//# sourceMappingURL=showBladeHeader.js.map